import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AlertBox from "../../Components/Alert";
import {
  Campus_Form_Checker,
  Campus_Form_Model,
} from "../../Models/CampusModel";
import {
  CAMPUS_CREATE_LIST,
  CAMPUS_CREATE_LIST_FORM_RESET,
  CAMPUS_SINGLE_DATA_RESET,
  CAMPUS_UPDATE_LIST,
  CAMPUS_UPDATE_LIST_FORM_RESET,
} from "../../Actions/campusAction";

export default function CreateCampus({
  handleFormClose,
  FormOpener,
  EditFormOpener,
  handleEditorForm,
  CampusLists_Get_Req,
  CampusID,
}) {
  const [CampusForm, setCampusForm] = useState(Campus_Form_Model);
  const [Alert, setAlert] = useState([]);
  const [Country_data, setCountry_data] = useState([]);
  const [University_data, setUniversity_data] = useState([]);

  const { Create_Campus_Loading, Create_Campus_Success, Create_Campus_Error } =
    useSelector((state) => state.CAMPUS_CREATE_REDUCER);

  const { Country_List } = useSelector((state) => state.COUNTRY_LIST_REDUCER);

  const { Update_Campus_Loading, Update_Campus_Success, Update_Campus_Error } =
    useSelector((state) => state.CAMPUS_UPDATE_REDUCER);

  const { UniversityList } = useSelector(
    (state) => state.UNIVERSITY_LIST_REDUCER
  );

  const { Campus_Single_Data } = useSelector(
    (state) => state.CAMPUS_SINGLE_DATA_REDUCER
  );

  const dispatch = useDispatch();

  const handleFormChange = (e) => {
    setCampusForm({
      ...CampusForm,
      [e.target.name]: e.target.value,
    });
    setAlert([]);
  };

  const handleFormCancel = () => {
    handleFormClose();
    dispatch(CAMPUS_CREATE_LIST_FORM_RESET());
    setAlert([]);
    setCampusForm(Campus_Form_Model);
  };

  const handleEditCancel = () => {
    handleEditorForm();
    setAlert([]);
    dispatch(CAMPUS_SINGLE_DATA_RESET());
    dispatch(CAMPUS_UPDATE_LIST_FORM_RESET());
    setCampusForm(Campus_Form_Model);
  };

  /*  University Web Details Create Error and Success handle start  */

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const FormCheck = Campus_Form_Checker(CampusForm);
    if (FormCheck[0] === "success") {
      dispatch(CAMPUS_CREATE_LIST(CampusForm));
    } else {
      setAlert(FormCheck);
    }
  };

  useEffect(() => {
    if (Create_Campus_Error) {
      setAlert([Create_Campus_Error]);
    }
    if (Create_Campus_Success) {
      setAlert([Create_Campus_Success]);

      setTimeout(() => {
        handleFormCancel();
        CampusLists_Get_Req();
      }, 1200);
    }
  }, [Create_Campus_Error, Create_Campus_Success]);

  /*  University Web Details Create Error and Success handle End */

  /*  University Web Details Edit Req Error and Success handle  */
  const handleEditFormSubmit = (e) => {
    e.preventDefault();
    const FormCheck = Campus_Form_Checker(CampusForm);
    if (FormCheck[0] === "success") {
      dispatch(CAMPUS_UPDATE_LIST(CampusID, CampusForm));
    } else {
      setAlert(FormCheck);
    }
  };

  useEffect(() => {
    if (Update_Campus_Error) {
      setAlert([Update_Campus_Error]);
    }
    if (Update_Campus_Success) {
      setAlert([Update_Campus_Success]);

      setTimeout(() => {
        handleEditCancel();
        CampusLists_Get_Req();
      }, 1200);
    }
  }, [Update_Campus_Success, Update_Campus_Error]);

  /*  University Web Details Edit Req Error and Success handle End  */

  useEffect(() => {
    setUniversity_data(UniversityList);
  }, [UniversityList]);

  useEffect(() => {
    setCountry_data(Country_List);
  }, [Country_List]);

  useEffect(() => {
    if (EditFormOpener && Campus_Single_Data) {
      setCampusForm(Campus_Single_Data[0]);
    }
  }, [EditFormOpener, Campus_Single_Data]);

  return (
    <>
      <div
        id="CreatContact"
        className={
          FormOpener || EditFormOpener ? "overlay-note w100 " : "overlay-note"
        }>
        <div className="Alert">
          {" "}
          {Alert.length > 0
            ? Alert.map((el, i) => (
                <AlertBox
                  key={i}
                  alert={el}
                  validator={
                    Create_Campus_Success || Update_Campus_Success
                      ? true
                      : false
                  }
                />
              ))
            : ""}{" "}
        </div>
        <div class="overlay-add-deals contact-right-side">
          <div class="note-title">
            <h4 class="text-left text-white pl-3">
              {EditFormOpener ? "Update Campus" : "Create Campus"}
            </h4>
            <a
              className="closebtn text-right text-white"
              onClick={() => {
                EditFormOpener ? handleEditCancel() : handleFormCancel();
              }}>
              &times;
            </a>
          </div>
          <div className="contact-body modify-create-contact   full_Form_Campus">
            <form
              onSubmit={
                EditFormOpener ? handleEditFormSubmit : handleFormSubmit
              }>
              <div className="form-group">
                <label>
                  Campus Name:<b>*</b>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Campus Name"
                  name="Campus_Name"
                  value={CampusForm.Campus_Name}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>
                  University Name:<b>*</b>
                </label>
                <select
                  type="number"
                  className="form-control"
                  placeholder="University_Id"
                  name={"University_Id"}
                  value={CampusForm.University_Id}
                  onChange={(e) => handleFormChange(e)}>
                  <option value="">Select University</option>
                  {University_data?.map((el) => (
                    <option key={el.University_Id} value={el.University_Id}>
                      {el.University_Name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>
                  Country Name:<b>*</b>
                </label>
                <select
                  type="number"
                  className="form-control"
                  placeholder="Enter Partnership"
                  name={"Country_Id"}
                  value={CampusForm.Country_Id}
                  onChange={(e) => handleFormChange(e)}>
                  <option value="">Select Country</option>
                  {Country_data?.map((el) => (
                    <option key={el.Id} value={el.Id}>
                      {el.Country}
                    </option>
                  ))}
                </select>
              </div>
              <div class="contact-footer w-100">
                {EditFormOpener ? (
                  <button
                    type="submit"
                    disabled={Update_Campus_Loading}
                    class="btn">
                    {Update_Campus_Loading ? "Loading.." : "Update Campus"}
                  </button>
                ) : (
                  <button
                    type="submit"
                    disabled={Create_Campus_Loading}
                    class="btn">
                    {Create_Campus_Loading ? "Loading..." : "Create Campus"}
                  </button>
                )}

                <button
                  type="button"
                  class="btn btn-deep-orange waves-effect waves-light"
                  onClick={() => {
                    EditFormOpener ? handleEditCancel() : handleFormCancel();
                  }}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
